<template>
  <div class="SpProgress flex-jc-bt" :style="style">
    <div :class="classes"
         :style="{width:width*progress-(tag?15:0)+'px', height: '5px'}" />
    <div v-if="tag" class="tag" :style="{lineHeight:height+'px'}">{{ tag }}</div>
  </div>
</template>

<script type="text/ecmascript-6">
import { computed } from '@vue/reactivity'
const Theme = {
  primary: 'sp-color-bg-13',
  gray: 'sp-color-bg-19'
}
export default {
  name: 'SpProgress',

  nameSpace: 'SpProgress',

  props: {
    width: {
      type: String,
      default: '194'
    },

    height: {
      type: String,
      default: '7'
    },

    progress: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: 'primary'
    },

    tag: {
      type: String,
      default: ''
    },

    border: {
      type: Boolean,
      default: true
    }
  },

  setup (props, ctx) {
    const classes = computed(() => {
      const type = Theme[props.type]
      return [type]
    })

    const style = computed(() => {
      const style = { width: props.width + 'px', height: props.height + 'px', boxSizing: 'border-box' }
      if (props.border) {
        style.border = '1px solid #7F7F7F'
      }
      return style
    })
    return {
      classes,
      style
    }
  }
}
</script>

<style scoped lang="less">
.SpProgress{
  position: relative;
  margin: 1px 0 1px 0;
  .tag{
    font-size: 12px;
    position: absolute;
    right: -16px;
  }
}
</style>
